import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';

export { CheckboxGroup };
export default Checkbox;



// WEBPACK FOOTER //
// ./src/checkbox/index.js